{
  "title": "Schedule Monitor",
  "loading": "Loading",
  "refresh": "Refresh",
  "lastSnapshot": "Last sync",
  "enabled": "Enabled",
  "disabled": "Disabled",
  "days": "d",
  "searchHint": "Search…",
  "searchTooltip": "Searchable: action / id / executionId / universalId / phase / status / error",
  "triggerSource": {
    "Schedule": "Scheduled",
    "Manual": "Manual",
    "Event": "Event",
    "Transient": "Transient"
  },
  "scheduleType": {
    "Cron": "Cron",
    "Once": "Once",
    "Startup": "Startup",
    "OnDemand": "On-Demand"
  },
  "jobStatus": {
    "title": "Job Status",
    "empty": "No job status yet",
    "colPhase": "Phase",
    "colStatus": "Status",
    "colAction": "Job",
    "colId": "ID",
    "colTime": "Time",
    "colRetry": "Retry",
    "colMessage": "Message"
  },
  "summary": {
    "total": "Total",
    "inProgress": "In Progress",
    "enabled": "Enabled",
    "retryChains": "Retry Chains"
  },
  "roster": {
    "title": "Schedules",
    "empty": "No schedules",
    "id": "ID",
    "description": "Description",
    "action": "Action",
    "type": "Type",
    "schedule": "Schedule",
    "nextFire": "Next Fire",
    "due": "Due",
    "autoAdvance": "Advance",
    "fixedRate": "Fixed Rate: next cycle scheduled immediately after firing",
    "fixedDelay": "Fixed Delay: next cycle scheduled after completion",
    "advanceNa": "One-time schedule has no advance policy (N/A)",
    "enabled": "Status",
    "operation": "Operation",
    "globalOffHint": "Scheduler is globally disabled (SchedulerEnabled=false): per-schedule toggling is unavailable; edit control.json to re-enable.",
    "srcManual": "Manual",
    "srcManualHint": "This schedule's on/off was set manually, overriding the config default."
  },
  "inProgress": {
    "title": "In-Progress Tasks",
    "empty": "No tasks in progress",
    "id": "ID",
    "action": "Action",
    "elapsed": "Elapsed",
    "startedAt": "Started"
  },
  "feed": {
    "title": "Live Feed",
    "empty": "No events yet",
    "colPhase": "Phase",
    "colStatus": "Status",
    "colAction": "Job",
    "colId": "ID",
    "colTime": "Time",
    "colRetry": "Retry",
    "colMessage": "Message"
  },
  "retry": {
    "title": "Retry Chains"
  },
  "phase": {
    "Dispatched": "Dispatched",
    "Succeeded": "Succeeded",
    "Failed": "Failed",
    "Retrying": "Retrying",
    "GaveUp": "Gave Up",
    "Running": "Running"
  },
  "detail": {
    "title": "Event Detail",
    "view": "View detail",
    "copy": "Copy",
    "copied": "Copied",
    "copyFailed": "Copy failed",
    "universalId": "Universal ID (batch)",
    "originalId": "Original ID (this run)",
    "executionId": "Execution ID",
    "phase": "Phase",
    "action": "Job",
    "triggerSource": "Trigger source",
    "scheduleType": "Schedule type",
    "jobSequenceNo": "Seq",
    "status": "Status",
    "retry": "Retry count",
    "dueTime": "Due time",
    "runTime": "Run time",
    "eventTime": "Event time",
    "lastError": "Error"
  },
  "manualTrigger": {
    "title": "Manually Trigger Schedule",
    "tooltip": "Trigger manually",
    "target": "Target",
    "secretLabel": "Enter your password to confirm",
    "secretPlaceholder": "Login password",
    "confirm": "Trigger",
    "cancel": "Cancel",
    "disabledWarning": "This schedule is currently disabled; manual trigger will force a one-time execution.",
    "params": {
      "section": "Extra parameters (optional)",
      "logicalTime": "Logical time",
      "logicalTimePlaceholder": "Leave empty to let the job decide",
      "keyPlaceholder": "Name",
      "valuePlaceholder": "Value",
      "add": "Add custom parameter",
      "hint": "Parameters are stored with an {'@'} prefix for jobs to read; whether a job uses a parameter is up to the backend.",
      "errFormat": "Name may contain letters, digits and underscore only",
      "errReserved": "This name conflicts with a predefined parameter",
      "errDuplicate": "Parameter names must be unique"
    },
    "notify": {
      "triggeredTitle": "Triggered",
      "triggeredDetail": "The schedule has started. Check the Live Feed for progress.",
      "wrongSecretTitle": "Incorrect password",
      "wrongSecretDetail": "The password is incorrect. Please re-enter and try again.",
      "authUnavailableTitle": "Cannot verify",
      "authUnavailableDetail": "Authentication service is temporarily unavailable. Try again later or contact your administrator.",
      "failedTitle": "Trigger failed",
      "failedDetail": "Could not trigger this schedule. Please try again later.",
      "forbiddenTitle": "Forbidden",
      "forbiddenDetail": "You do not have permission to trigger this schedule. This action is restricted to administrators."
    }
  },
  "setEnabled": {
    "title": "Schedule On/Off",
    "target": "Target schedule",
    "toEnable": "Will enable",
    "toDisable": "Will disable",
    "reasonLabel": "Reason (optional)",
    "reasonPlaceholder": "Reason for change, can be empty",
    "secretLabel": "Confirm password",
    "secretPlaceholder": "Enter your login password",
    "cancel": "Cancel",
    "confirm": "Confirm",
    "enableTip": "Enable this schedule",
    "disableTip": "Disable this schedule",
    "globalOffTip": "Scheduler globally disabled; toggling unavailable",
    "notify": {
      "sentTitle": "Sent",
      "sentDetail": "Request sent; the list will update shortly",
      "wrongSecretTitle": "Wrong password",
      "wrongSecretDetail": "Please check your login password",
      "authUnavailableTitle": "Auth unavailable",
      "authUnavailableDetail": "Please try again later",
      "reasonTooLongTitle": "Reason too long",
      "reasonTooLongDetail": "Reason must be 200 characters or fewer",
      "failedTitle": "Operation failed",
      "failedDetail": "Please try again later",
      "forbiddenTitle": "Forbidden",
      "forbiddenDetail": "You do not have permission to change this schedule. This action is restricted to administrators."
    }
  },
  "history": {
    "title": "Execution History",
    "selectSchedule": "Select schedule (multi)",
    "selectPlaceholder": "Pick from current schedules…",
    "queryByValue": "Or query by",
    "valuePlaceholder": "Enter full value (by type; SourceId reaches deleted/transient)",
    "dateRange": "Time range",
    "phase": "Final phase",
    "statusAll": "All",
    "query": "Search",
    "empty": "No execution records",
    "col": {
      "phase": "Phase",
      "status": "Status",
      "action": "Action",
      "id": "ID",
      "time": "Time",
      "retries": "Retry",
      "lastError": "Last error"
    },
    "chain": {
      "phase": "Phase",
      "time": "Time",
      "retry": "Retry",
      "exec": "Execution ID",
      "error": "Error",
      "empty": "No events"
    },
    "notify": {
      "failedTitle": "Query failed",
      "failedDetail": "Could not load execution history, please try again."
    }
  }
}